<template>
    <div>
        <flCabecalhoForm :msg="_traducao('global','obrigatorio')" cls="print-titulo-form-20" :texto="'Tipo do Usuário'" />

        <div class="row">
            <div class="col-xs-12 form-group" :class="{'has-error': erroTipo != ''}">
                <label>{{_traducao('global', 'tipoDeUsuario')}}:</label><br />
                <div class="btn-group" role="group">
                    <button type="button"  @click="tipo = 'O'; limpaForm()"
                            :class="{'btn-info': tipo == 'O'}"
                            class="btn btn-default btn-sm">
                        {{_traducao('global', 'operacional').toUpperCase()}}
                    </button>
                    <button type="button" @click="tipo = 'S'; limpaForm()"
                            :class="{'btn-info': tipo == 'S'}"
                            class="btn btn-default btn-sm">
                        {{_traducao('global', 'solicitante').toUpperCase()}}
                    </button>
                </div><br/>
				<h4 style="color: red;" v-if="tipo == 'S'">{{_traducao('global', 'solicitanteSelecionado').toUpperCase()}}</h4>
                <p class="help-block" v-if="erroTipo != ''">{{erroTipo}}</p>
            </div>
        </div>

		<!-- TIPO DE USUÁRIO -->
        <div class="row" v-if="tipo == 'O'">
			<!-- MASP/NÙMERO FUNCIONAL -->
            <div class="col-xs-12 col-md-3 form-group" :class="{'has-error' : erro.masp != ''}">
                <label><span class="no-print">* </span>Número Funcional:</label>
                <input type="text" v-model="form.masp" class="form-control input-sm">
                <p class="help-block"  v-show="erro.masp != ''">{{erro.masp}}</p>
            </div>
			<!-- MASP/NÙMERO FUNCIONAL -->

			<!-- DATA DE NASCIMENTO -->
            <div class="col-xs-12 col-md-3 form-group" :class="{'has-error' : erro.data_nascimento != ''}">
                <label><span class="no-print">* </span>{{_traducao('global', 'dataNascimento')}}:</label>
                <flDateTime @v-model="(val) => form.data_nascimento = val"
                    :value="form.data_nascimento"
                    :lang="_getLangDp"
                    :format="_formatDate"
                    name="datanascimento" />
                <p class="help-block"  v-show="erro.data_nascimento != ''">{{erro.data_nascimento}}</p>
            </div>
			<!-- DATA DE NASCIMENTO -->

			<!-- CARGO -->
            <div class="col-xs-12 col-md-3 form-group" :class="{'has-error' : erro.cargo != ''}">
                <label><span class="no-print">* </span>{{_traducao('menuAGnovoUsuario','menuAGcargo')}}:</label>
                <select class="form-control input-sm" v-model="form.cargo">
                    <option value="">{{_traducao('global','escolha').toUpperCase()}}</option>
                    <option v-for="(item, index) in cargos" :value="item.id" :key="index" >{{item.descricao}}</option>
                </select>
                <p class="help-block" v-show="erro.cargo != ''">{{erro.cargo}}</p>
            </div>
			<!-- CARGO -->

			<!-- NOME DE TRATAMENTO -->
            <div class="col-xs-12 col-md-3 form-group" :class="{'has-error' : erro.nome_guerra != ''}">
                <label><span class="no-print">* </span>{{_traducao('global', 'nomeTratamento')}}:</label>
                <input type="text" v-model="form.nome_guerra" class="form-control input-sm">
                <p class="help-block"  v-show="erro.nome_guerra != ''">{{erro.nome_guerra}}</p>
            </div>
			<!-- NOME DE TRATAMENTO -->

			<!-- POSTO/GRADUAÇÃO -->
            <div class="col-xs-12 col-md-3 form-group">
                <label>{{_traducao('menuAGnovoUsuario','menuAGposto')}}:</label>
                <select v-model="form.id_posto_graduacao" class="form-control input-sm">
                    <option value="">{{_traducao('global','escolha').toUpperCase()}}</option>
                    <option v-for="(item, index) in postos" :value="item.id" :key="index">{{item.descricao}}</option>
                </select>
            </div>
			<!-- POSTO/GRADUAÇÃO -->

            <div class="col-xs-12">
				<!-- TIPO SANGUINEO/ALERGIA/FATOR RH -->
                <fl-emergencia ref="emergencia"
                    @dados-emergencia="(item) => { dadosEmergencia = item }"
                />
            </div>

            <div class="col-xs-12">
				<!-- NOME/GRAU/TELEFONE/CELULAR EMERGÊNCIAL -->
                <fl-contato-emergencial ref="contato_emergencia"
                    @dados-contato-emergencial="(item) => {
                        dadosContatoEmergencial = item.form,
                        dadosEnderecoEmergencia = item.endereco
                    }"
                />
            </div>
        </div>
		<!-- TIPO DE USUÁRIO -->

    </div>
</template>
<script>
import flEmergencia from '../componentes/emergencia.vue'
import flContatoEmergencial from '../componentes/contato-emergencia.vue'
export default {
    components: {
        flEmergencia , flContatoEmergencial
    },
    props: {
        postos: {
            type: Array
        },

        cargos: {
            type: Array
        },
        menu: {
            type: Boolean
        }
    },
    data () {
        return {
            tipo: '',
            erroTipo: '',
            dadosEmergencia: {
                alergia: "",
                fator_rh: "",
                tipo_sanguineo: "",
            },

            dadosContatoEmergencial: {
                celular_emergencia: "",
                grau_emergencia: "",
                nome_emergencia: "",
                telefone_emergencia: "",
            },

            dadosEnderecoEmergencia: {
                bairro: "",
                cep: "",
                cidade: "",
                complemento: "",
                estado: "",
                logradouro: "",
                numero: "",
            },

            form: {
                masp: '',
                data_nascimento:'',
                cargo:'',
                nome_guerra:'',
                id_posto_graduacao:''
            },

            erro: {
                houve_contexto: '',
                masp: '',
                data_nascimento:'',
                cargo:'',
                nome_guerra:'',
                id_posto_graduacao:''
            }
        }
    },

    methods: {
        editar (item) {
            this.form.masp = item.masp
            this.form.data_nascimento = this._SQLDateToDate(item.data_nascimento, $sessao.getDateFormat())
            this.form.cargo = item.cargo
            this.form.nome_guerra = item.nome_guerra
            this.form.id_posto_graduacao = item.id_posto_graduacao
            this.tipo = item.tipo

            if(this.tipo == 'O'){
                this.$nextTick(() => {
                    this.$refs.emergencia.editar(item)

                })
                this.$nextTick(() => {
                    this.$refs.contato_emergencia.editar(item)
                })

            }
        },
        limpaForm () {
            this.dadosEmergencia = {
                alergia: "",
                fator_rh: "",
                tipo_sanguineo: "",
            }

            this.dadosContatoEmergencial = {
                celular_emergencia: "",
                grau_emergencia: "",
                nome_emergencia: "",
                telefone_emergencia: "",
            }

            this.dadosEnderecoEmergencia = {
                bairro: "",
                cep: "",
                cidade: "",
                complemento: "",
                estado: "",
                logradouro: "",
                numero: "",
            }

            this.form = {
                masp: '',
                data_nascimento:'',
                cargo:'',
                nome_guerra:'',
                id_posto_graduacao:''
            }

            this.erroTipo = ''

            this.erro = {
                masp: '',
                data_nascimento:'',
                cargo:'',
                nome_guerra:''
            }
        },

        validaForm () {
            let passou = true
            let obg = this._traducao('global', 'campoObrigatorio')

            if(this.tipo == ''){
                this.erroTipo = obg
                passou = false
            }else {
                this.erroTipo = ''
            }

            if(this.tipo == 'O'){
                if(this.form.masp == ''){
                    this.erro.masp = obg
                    passou = false
                }else{
                    this.erro.masp = ''
                }

                if(this.form.data_nascimento == ''){
                    this.erro.data_nascimento = obg
                    passou = false
                }else{
                    this.erro.data_nascimento = ''
                }

                if(this.form.cargo == ''){
                    this.erro.cargo = obg
                    passou = false
                }else{
                    this.erro.cargo = ''
                }

                if(this.form.nome_guerra == ''){
                    this.erro.nome_guerra = obg
                    passou = false
                }else{
                    this.erro.nome_guerra = ''
                }

                if(!this.$refs.emergencia.validaForm()){
                    passou = false
                }

                if(!this.$refs.contato_emergencia.validaForm()){
                    passou = false
                }
            }

			// ENVIA AS INFORMAÇÕES PARA O CADASTRO
            if(passou){
                this.$emit('dados-adicionais', {
                    form: this.form,
                    dados: this.dadosEmergencia,
                    contato: this.dadosContatoEmergencial,
                    endereco: this.dadosEnderecoEmergencia,
                    tipo: this.tipo
                })
            }

            return passou
        }
    }
}
</script>